import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "account-type-wrapper" }
const _hoisted_2 = { class: "account-type-block" }
const _hoisted_3 = { class: "account-type-block border-bottom" }
const _hoisted_4 = {
  key: 0,
  class: "account-type-block"
}
const _hoisted_5 = { class: "custom-field-wrapper" }
const _hoisted_6 = {
  key: 1,
  class: "checkbox-wrapper"
}
const _hoisted_7 = { class: "footer-btns fixed" }

import { computed, reactive, onMounted, ref } from 'vue'
import { Toast } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import useOpenInfo from '@/hooks/openInfo'
import {
  isInAppWebview,
  setApptitle
} from '@/utils/native-app'
import { useMutation } from '@vue/apollo-composable'
import { dobuleSaveDraft } from '@/graphql/mutation'
import * as storage from '@/utils/storage'
import stepPercentage from '@/utils/number'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()

const {
  openInfo,
  openType,
  meta,
  step,
  title,
  saveOpenInfoOfVuex,
  saveCommonOfVuex
} = useOpenInfo()

const formType = computed(() => route.query.type || storage.get('formType'))

const commomParams = ref()

const state = reactive({
  isSetSubAccount: 1,
  subAccountNum: 2,
  subAccountRatio: ['50%', '50%']
} as any)

const subAccountRatioMap = {
  0: [],
  1: [100],
  2: [50, 50],
  3: [30, 30, 40],
  4: [20, 20, 30, 30],
  5: [20, 20, 20, 20, 20]
} as any

// 判断是否在金马app内
const isApp = computed(() => isInAppWebview())

const handleSubAccountNumClickRightIcon = () => {
  state.subAccountNum = state.subAccountNum + 1
  if (state.subAccountNum >= 3) {
    state.subAccountNum = 3
  }
  state.subAccountRatio = subAccountRatioMap[state.subAccountNum]
}

const handleSubAccountNumClickLeftIcon = () => {
  state.subAccountNum = state.subAccountNum - 1
  if (state.subAccountNum <= 0) {
    state.subAccountNum = 0
  }
  state.subAccountRatio = subAccountRatioMap[state.subAccountNum]
}

const handleSubAccountRatioClickRightIcon = (e: any, i: number) => {
  state.subAccountRatio = state.subAccountRatio.map((v: any) => {
    if (typeof v === 'number') {
      return v
    }
    return +v.split('%')[0]
  })
  state.subAccountRatio[i] = +state.subAccountRatio[i] + 10
  if (state.subAccountRatio[i] > 100) {
    state.subAccountRatio[i] = 100
  }
  if (state.subAccountRatio[i] < 0) {
    state.subAccountRatio[i] = 0
  }
}

const handleSubAccountRatioClickLeftIcon = (e: any, i: number) => {
  state.subAccountRatio = state.subAccountRatio.map((v: any) => {
    if (typeof v === 'number') {
      return v
    }
    return +v.split('%')[0]
  })
  state.subAccountRatio[i] = +state.subAccountRatio[i] - 10
  if (state.subAccountRatio[i] < 0) {
    state.subAccountRatio[i] = 0
  }
  if (state.subAccountRatio[i] > 100) {
    state.subAccountRatio[i] = 100
  }
}

const handleNext = async () => {
  state.subAccountRatio = state.subAccountRatio.map(v => +`${v}`?.split('%')[0])
  const total = state.subAccountRatio.reduce((a, b) => a + b, 0)
  if (total !== 100 && state.isSetSubAccount === 1 && state.subAccountNum > 0) {
    Toast('分配比例之和应为100')
    return
  }

  if (state.isSetSubAccount === 0) {
    state.subAccountNum = 0
    state.subAccountRatio = []
  }
  const percentage = stepPercentage(step)

  // const params = {
  //   meta: meta.value,
  //   content: JSON.stringify({
  //     subAccountNum: state.subAccountNum,
  //     subAccountRatio: state.subAccountRatio.map((v: any) => {
  //       if (typeof v === 'number') {
  //         return v
  //       }
  //       return +v.split('%')[0]
  //     }),
  //     isSetSubAccount: state.isSetSubAccount
  //   })
  // }
  commomParams.value = {
    openType: openType.value,
    openStatus: 0,
    btnText: '继续开户',
    remark: '已完成3%，请继续完善资料',
    step
  }
  // useSaveOpenInfo(params).then(() => {
  //   const common = {
  //     openType: openType.value,
  //     openStatus: 0,
  //     btnText: '继续开户',
  //     remark: '已完成3%，请继续完善资料',
  //     step
  //   }
  //   useMutationCommon(common)
  //   saveCommonOfVuex({ info: common })
  //   saveOpenInfoOfVuex({ info: state })
  //   router.push({ name: 'id-card' })
  // })

  saveClientDraft({
    param: {
      formType: formType.value,
      meta: meta.value,
      content: JSON.stringify({
        subAccountNum: state.subAccountNum,
        subAccountRatio: state.subAccountRatio.map((v: any) => {
          if (typeof v === 'number') {
            return v
          }
          return +v.split('%')[0]
        }),
        isSetSubAccount: state.isSetSubAccount
      })
    },
    commomParams: {
      formType: formType.value,
      meta: 'open_common',
      content: JSON.stringify(commomParams.value)
    }
  })
}

const initData = () => {
  const { subAccountRatio = [50, 50], subAccountNum = 2, isSetSubAccount = 1 } = openInfo.value
  state.subAccountRatio = subAccountRatio
  state.subAccountNum = subAccountNum
  state.isSetSubAccount = isSetSubAccount
}

const handlePre = () => {
  router.push({ name: 'id-type' })
}

// 存储缓存表方法
const { mutate: saveClientDraft, onDone } = useMutation(dobuleSaveDraft)

onDone((res) => {
  const { saveClientFormDraft, commonDraft } = res.data
  if (saveClientFormDraft.ok && commonDraft.ok) {
    saveCommonOfVuex({ info: commomParams.value })
    saveOpenInfoOfVuex({ info: state })
    router.push({ name: 'id-card' })
  }
})

onMounted(() => {
  setApptitle(title)
  initData()
})

return (_ctx: any,_cache: any) => {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "account-type-head" }, [
        _createElementVNode("div", { class: "line" }),
        _createElementVNode("div", { class: "account-type-title" }, "账户类型")
      ], -1)),
      _createVNode(_component_van_radio_group, { direction: "horizontal" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_radio, { name: "1" }, {
            icon: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("i", {
                class: "iconfont icon-xuanze1",
                style: {"color":"#FFB400"}
              }, null, -1)
            ])),
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createTextVNode(" 现金账户 "))
            ]),
            _: 1
          }),
          _createVNode(_component_van_radio, { name: "2" }, {
            icon: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("i", {
                class: "iconfont icon-xuanze1",
                style: {"color":"#FFB400"}
              }, null, -1)
            ])),
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createTextVNode(" 保证金账户 "))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "split-line" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "account-type-head-1" }, [
        _createElementVNode("div", { class: "account-type-title-1" }, "是否设定子账户")
      ], -1)),
      _createVNode(_component_van_radio_group, {
        modelValue: state.isSetSubAccount,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.isSetSubAccount) = $event)),
        direction: "horizontal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_radio, { name: 1 }, {
            icon: _withCtx(() => [
              _createElementVNode("i", {
                class: "iconfont icon-xuanze1",
                style: _normalizeStyle(state.isSetSubAccount == 1 ? { color: '#FFB400' } : { color: '#525A75' })
              }, null, 4)
            ]),
            default: _withCtx(() => [
              _cache[7] || (_cache[7] = _createTextVNode(" 是 "))
            ]),
            _: 1
          }),
          _createVNode(_component_van_radio, { name: 0 }, {
            icon: _withCtx(() => [
              _createElementVNode("i", {
                class: "iconfont icon-xuanze1",
                style: _normalizeStyle(state.isSetSubAccount == 0 ? { color: '#FFB400' } : { color: '#525A75' })
              }, null, 4)
            ]),
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createTextVNode(" 否 (")),
              _cache[9] || (_cache[9] = _createElementVNode("span", { style: {"font-size":"12px"} }, "开户完成后也可再拆分子账户", -1)),
              _cache[10] || (_cache[10] = _createTextVNode("） "))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (state.isSetSubAccount === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "account-type-head" }, [
            _createElementVNode("div", { class: "account-type-title-2" }, "子账户类型：现金账户")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "custom-field-label" }, "子账户数量", -1)),
            _createVNode(_component_van_field, {
              class: "custom-field",
              type: "number",
              modelValue: state.subAccountNum,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.subAccountNum) = $event)),
              modelModifiers: { number: true },
              "input-align": "center",
              border: false,
              onClickRightIcon: handleSubAccountNumClickRightIcon,
              onClickLeftIcon: handleSubAccountNumClickLeftIcon,
              disabled: ""
            }, {
              "right-icon": _withCtx(() => _cache[12] || (_cache[12] = [
                _createElementVNode("div", { class: "custom-field-icon custom-field-icon-add" }, null, -1)
              ])),
              "left-icon": _withCtx(() => _cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "custom-field-icon custom-field-icon-minus" }, null, -1)
              ])),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.subAccountNum, (v, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "custom-field-wrapper custom-field-wrapper-1",
              key: i
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "custom-field-label" }, "分配比例", -1)),
              _createVNode(_component_van_field, {
                class: "custom-field",
                type: "number",
                modelValue: state.subAccountRatio[i],
                "onUpdate:modelValue": ($event: any) => ((state.subAccountRatio[i]) = $event),
                formatter: v => `${v}%`,
                "input-align": "center",
                maxlength: 3,
                border: false,
                disabled: "",
                onClickRightIcon: e => handleSubAccountRatioClickRightIcon(e, i),
                onClickLeftIcon: e => handleSubAccountRatioClickLeftIcon(e, i)
              }, {
                "left-icon": _withCtx(() => _cache[15] || (_cache[15] = [
                  _createElementVNode("div", { class: "custom-field-icon custom-field-icon-minus" }, null, -1)
                ])),
                "right-icon": _withCtx(() => _cache[16] || (_cache[16] = [
                  _createElementVNode("div", { class: "custom-field-icon custom-field-icon-add" }, null, -1)
                ])),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "formatter", "onClickRightIcon", "onClickLeftIcon"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (state.isSetSubAccount === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[19] || (_cache[19] = [
          _createElementVNode("div", { class: "checked" }, null, -1),
          _createElementVNode("div", { class: "checkbox-label" }, "本次所有子账户将使用您已开户的资料", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_van_button, {
        plain: "",
        size: "small",
        class: "btn-preview",
        onClick: handlePre
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [
          _createTextVNode("上一步")
        ])),
        _: 1
      }),
      _createVNode(_component_van_button, {
        class: "btn-next",
        size: "small",
        "native-type": "submit",
        type: "primary",
        onClick: handleNext
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createTextVNode("下一步")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})